import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import { ImageService } from '../../core/services/image.service';
import { EventService } from '../../core/services/event.service';
import {Angulartics2} from "angulartics2";

@Component({
    selector: 'main-tab',
    templateUrl: './main.tab.html',
    styleUrls: ['./profile.page.scss']
})

export class ProfileMainTab implements OnInit {
    @Output() onFormAdd = new EventEmitter();

    dictData: any;

    constructor(
        public route: ActivatedRoute,
        public imageService: ImageService,
        public eventService: EventService,
        private angulartics2: Angulartics2
    ) {}

    ngOnInit() {
        this.dictData = this.route.snapshot.data['common'];
        this.angulartics2.eventTrack.next({
            action: 'View Profile',
            properties: {category: 'Profile'}
        });
    }

    addForm(form) {
        this.onFormAdd.emit(form);
    }
}

